<template>
    <AdminPageInner :breadcrumbs="breadcrumbs">
        <template #heading>Admin Dashboard</template>
    </AdminPageInner>
</template>

<script>

import AdminPageInner from "@/Components/Layout/AdminPageInner";

export default {

    name: "DashboardPage",

    data() {
        return {}
    },

    components: {
        AdminPageInner
    },

    computed: {
        breadcrumbs() {
            return [
                {label: 'Admin', to: {name: this.$route.name}},
            ];
        },
    }
};

</script>
